var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33332 1.66675H16.6667C17.5833 1.66675 18.3333 2.41675 18.3333 3.33341V16.6667C18.3333 17.5834 17.5833 18.3334 16.6667 18.3334H3.33332C2.41666 18.3334 1.66666 17.5834 1.66666 16.6667V3.33341C1.66666 2.41675 2.41666 1.66675 3.33332 1.66675ZM3.33332 16.6667H6.66666V13.3334H3.33332V16.6667ZM6.66666 11.6667H3.33332V8.33341H6.66666V11.6667ZM3.33332 6.66675H6.66666V3.33341H3.33332V6.66675ZM11.6667 16.6667H8.33332V13.3334H11.6667V16.6667ZM8.33332 11.6667H11.6667V8.33341H8.33332V11.6667ZM11.6667 6.66675H8.33332V3.33341H11.6667V6.66675ZM13.3333 16.6667H16.6667V13.3334H13.3333V16.6667ZM16.6667 11.6667H13.3333V8.33341H16.6667V11.6667ZM13.3333 6.66675H16.6667V3.33341H13.3333V6.66675Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.8be64709bd97d93c83069a677010fe31.svg";
export { ForwardRef as ReactComponent };